import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import PATListEntry from './PATListEntry.vue'
import { api } from '../adminApi'
import { GetTokenResponse } from '../generated/api'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'PATList',
  props: {
    email: null
  },
  setup(__props: any) {

const props = __props as {
  email: string,
}




const pats = ref([] as GetTokenResponse[])

async function fetch() {

  try {
    const response = await api.getTokens()
    pats.value = response.data
  } catch (error) {
    console.log(error)
  }
}

function refresh() {
  fetch()
}

fetch()


return { __sfc: true,props, pats, fetch, refresh, PATListEntry }
}

})